
import { Vue, Component, Prop } from "vue-property-decorator";

import Loader from "@/components/Loader.vue";
import Gallery, { ResourceMeta } from "@/components/Gallery.vue";
import PrintButton from "@/components/PrintButton.vue";

@Component({ components: { Loader, Gallery, PrintButton } })
export default class Stammdaten extends Vue {
  @Prop({ required: true })
  id!: string;

  imageResourceMeta: ResourceMeta = {
    application: "pegel",
    resource: "foto",
    id: String(this.id)
  };
  stammdaten: any = null;
  imageLink() {
    const messstellenFotoUrl =
      "https://geodaten-wasser.rlp-umwelt.de/mdat_wasser/";
    const fotoQuery = "pegel/foto/";
    const id = this.id;
    const fileType = ".jpg";
    return messstellenFotoUrl + fotoQuery + id + fileType;
  }

  loadedStammdaten(data) {
    this.stammdaten = data;
    this.$parent?.$parent?.$parent?.$emit("isDfUE", this.stammdaten[0].dfue);
  }
}
